import icon from 'assets/img/logo-short.svg'

const Loader = () => {
  return (
    <div className='page-loader'>
      <img src={icon} alt="" />
    </div>
  )
}

export default Loader;
